import React from "react";
import "./ProjectCards.css";
import { data } from "./projects.js";
import { GoLinkExternal } from "react-icons/go";

const ProjectCards = () => {
  const incoming_data = data;
  console.log(incoming_data);
  return (
    <>
      <div className=" main">
        {incoming_data.map((ele) => {
          return (
            <div className="card">
              <div className="cards">
                <img
                  src={ele.image}
                  alt="my_project"
                  style={{ width: "50%" }}
                />
              </div>
              <div className="card-body">
                <h2>{ele.name}</h2>

                <p>{ele.description}</p>
                <div className="techs">
                  {ele.tec.map((e) => {
                    return <a className="tecs">{e}</a>;
                  })}
                </div>
                <a
                  href={ele.link}
                  target="_blank"
                  className="linkbtn"
                  rel="noreferrer"
                >
                  <GoLinkExternal />
                  visit
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ProjectCards;
